import React from "react"
import { connect } from "react-redux"

import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"

import dayjs from "dayjs"

import { selectPeriod } from "../reducers/cloudReducer"

import { useTranslation } from "react-i18next"

const SelectPeriod = (props) => {
  const { t } = useTranslation("selectPeriod")

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{t("period")}</InputLabel>
      <Select
        fullWidth
        value={props.period}
        onChange={(event) => props.selectPeriod(event.target.value)}
      >
        {props.periods.map((p) => (
          <MenuItem value={p} id={p.alkaa} key={p.alkaa}>
            {dayjs(p.alkaa).format("DD.MM.YYYY") +
              " " +
              dayjs(p.loppuu).format("DD.MM.YYYY")}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const mapStateToProps = (state) => {
  return {
    period: state.cloud ? state.cloud.period : null,
    periods: state.cloud && state.cloud.init ? state.cloud.init.tilikaudet : [],
  }
}

export default connect(mapStateToProps, { selectPeriod })(SelectPeriod)
